import { render, staticRenderFns } from "./ToolsFormEdgeContact.vue?vue&type=template&id=2ce8a221&scoped=true"
import script from "./ToolsFormEdgeContact.vue?vue&type=script&lang=js"
export * from "./ToolsFormEdgeContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce8a221",
  null
  
)

export default component.exports